let cachedCookieDomain: null | string = null;
/**
 * Get the part of the cookie as string to define the domain
 * @param hostname hostname of the current web
 * @returns Return the part of the cookie to get the domain to use for cookies
 * Take care of domains like:
 * https://www.tui.co.uk/things-to-do/ (be ceraful with .co.uk TLD)
 * https://www.musement.com/
 */
function getTextCookieDomain(hostname = window.location.hostname): string {
  if (!cachedCookieDomain) {
    const domain = hostname.replace("www.", "");
    cachedCookieDomain = ";domain=" + domain;
  }
  return cachedCookieDomain;
}

function getCookie(name: string): string | null {
  const v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

function getCookieObject(name: string):
  | {
      [key: string]: string;
    }
  | null
  | undefined {
  const cookieData = getCookie(name);
  if (!cookieData) return null;
  if (cookieData === "undefined") return undefined;
  return JSON.parse(decodeURIComponent(cookieData));
}

function setCookie({
  name,
  value,
  expireInDays,
}: {
  name: string;
  value: number | string;
  expireInDays?: number;
}): void {
  let expiresValue = "";
  if (expireInDays) {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * expireInDays);
    expiresValue = `;expires=${d.toUTCString()}`;
  }

  window.document.cookie =
    name + "=" + value + ";path=/" + expiresValue + getTextCookieDomain();
}

function setCookieObject({
  name,
  value,
  expireInDays,
}: {
  name: string;
  value: {
    [key: string]: unknown;
  };
  expireInDays?: number;
}): void {
  return setCookie({
    name,
    value: encodeURIComponent(JSON.stringify(value)),
    expireInDays,
  });
}

function deleteCookie(name: string): void {
  document.cookie =
    name +
    "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;" +
    getTextCookieDomain();
}

export {
  getCookie,
  getCookieObject,
  setCookie,
  setCookieObject,
  deleteCookie,
  getTextCookieDomain,
};

export function resetCachedCookieDomain(): void {
  if (process.env["NODE_DEV"] == "test") {
    cachedCookieDomain = null;
  }
}
